document.addEventListener('DOMContentLoaded', () => {
  // Menú móvil
  const menu = document.querySelector('[data-menu]');
  document.querySelector('[data-menu-open]')?.addEventListener('click', () => menu?.classList.add('open'));
  document.querySelector('[data-menu-close]')?.addEventListener('click', () => menu?.classList.remove('open'));
  menu?.addEventListener('click', e => { if (e.target === menu) menu.classList.remove('open') });

  // Menú desplegable de escritorio: usamos JS con un pequeño margen de tiempo
  // para que el submenú no se cierre al mover el ratón en diagonal.
  const closeDelay = 250;
  function setupHoverGroup(el, openClass) {
    let timer;
    el.addEventListener('mouseenter', () => {
      clearTimeout(timer);
      el.classList.add(openClass);
    });
    el.addEventListener('mouseleave', () => {
      timer = setTimeout(() => el.classList.remove(openClass), closeDelay);
    });
  }
  document.querySelectorAll('.nav-item').forEach(item => setupHoverGroup(item, 'is-open'));
  document.querySelectorAll('.dropdown-item.has-flyout').forEach(item => setupHoverGroup(item, 'is-open'));
});

// Página de producto: cambiar imagen al pulsar miniaturas y actualizar precio según variante
document.addEventListener('DOMContentLoaded', () => {
  const mainImg = document.querySelector('[data-gallery-main] img');
  document.querySelectorAll('[data-thumb]').forEach(btn => {
    btn.addEventListener('click', () => {
      if (mainImg) mainImg.src = btn.dataset.full;
      document.querySelectorAll('[data-thumb]').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  const select = document.querySelector('[data-variant-select]');
  select?.addEventListener('change', () => {
    const opt = select.selectedOptions[0];
    const price = document.querySelector('[data-price]');
    const compare = document.querySelector('[data-compare]');
    if (price) price.textContent = opt.dataset.price;
    if (compare) {
      if (opt.dataset.compare) { compare.textContent = opt.dataset.compare; compare.hidden = false; }
      else compare.hidden = true;
    }
  });
});

// Zoom con lupa en la imagen principal del producto
document.addEventListener('DOMContentLoaded', () => {
  const zone = document.querySelector('[data-gallery-main]');
  if (!zone || !zone.querySelector('img')) return;
  zone.classList.add('zoomable');
  zone.addEventListener('mousemove', e => {
    const imgs = zone.querySelectorAll('img');
    if (!imgs.length) return;
    const r = zone.getBoundingClientRect();
    const x = ((e.clientX - r.left) / r.width) * 100;
    const y = ((e.clientY - r.top) / r.height) * 100;
    imgs.forEach(img => { img.style.transformOrigin = `${x}% ${y}%`; });
  });
  zone.addEventListener('mouseleave', () => {
    zone.querySelectorAll('img').forEach(img => { img.style.transformOrigin = 'center center'; });
  });
});

// Cesta: actualizar subtotal y precios dinámicamente al cambiar cantidades
document.addEventListener('DOMContentLoaded', () => {
  const cartPage = document.querySelector('.cart-page');
  if (!cartPage) return;

  const formatMoney = (cents, currency) =>
    new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency }).format(cents / 100);

  async function commitQtyChange(input) {
    const line = input.closest('[data-line-key]');
    const key = line?.dataset.lineKey;
    let qty = parseInt(input.value, 10);
    if (!key || isNaN(qty) || qty < 0) return;

    const max = input.dataset.maxStock;
    if (max && qty > parseInt(max, 10)) {
      qty = parseInt(max, 10);
      input.value = qty;
      showToast(`Solo quedan ${max} unidades online. Si necesitas más, consúltanos: puede que tengamos stock en tienda.`, true);
    }

    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: { [key]: qty } })
      });
      if (!res.ok) throw new Error('Error al actualizar');
      const cart = await res.json();

      if (qty === 0) { location.reload(); return; }

      const item = cart.items.find(i => i.key === key);
      const linePrice = line.querySelector('[data-line-price]');
      if (item && linePrice) linePrice.textContent = formatMoney(item.final_line_price, cart.currency);

      const subtotal = document.querySelector('[data-cart-subtotal]');
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price, cart.currency);

      const cartCount = document.querySelector('.cart-button span');
      if (cartCount) {
        const totalItems = cart.items.reduce((total, item) => {
          return total + (item.properties && item.properties._tela ? 1 : item.quantity);
        }, 0);
        cartCount.textContent = totalItems;
      }
    } catch (e) {
      location.reload();
    }
  }

  let timer;
  cartPage.querySelectorAll('.cart-line-qty input').forEach(input => {
    input.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(() => commitQtyChange(input), 400);
    });

    // Evita que Intro envíe el formulario completo antes de corregir el valor
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        clearTimeout(timer);
        commitQtyChange(input);
      }
    });
  });

  // Red de seguridad: si aun así se envía el formulario (botón "Actualizar cesta"
  // o "Tramitar pedido"), corrige cualquier cantidad que supere el stock antes de enviarlo
  cartPage.querySelector('form')?.addEventListener('submit', () => {
    cartPage.querySelectorAll('.cart-line-qty input').forEach(input => {
      const max = input.dataset.maxStock;
      if (max && parseInt(input.value, 10) > parseInt(max, 10)) {
        input.value = max;
      }
    });
  });
});

// ===== Cesta: eliminar línea sin recargar =====
document.addEventListener('DOMContentLoaded', () => {
  const cartPage = document.querySelector('.cart-page');
  if (!cartPage) return;

  const formatMoney = (cents, currency) =>
    new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency }).format(cents / 100);

  cartPage.querySelectorAll('[data-cart-remove]').forEach(btn => {
    btn.addEventListener('click', async () => {
      const line = btn.closest('[data-line-key]');
      const key = line?.dataset.lineKey;
      if (!key) return;
      btn.disabled = true;

      try {
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: { [key]: 0 } })
        });
        if (!res.ok) throw new Error('Error al eliminar');
        const cart = await res.json();

        if (cart.item_count === 0) { location.reload(); return; }

        line.remove();

        const subtotal = document.querySelector('[data-cart-subtotal]');
        if (subtotal) subtotal.textContent = formatMoney(cart.total_price, cart.currency);

        const cartCount = document.querySelector('.cart-button span');
        if (cartCount) {
          const totalItems = cart.items.reduce((total, item) => {
            return total + (item.properties && item.properties._tela ? 1 : item.quantity);
          }, 0);
          cartCount.textContent = totalItems;
        }
      } catch (e) {
        location.reload();
      }
    });
  });
});

// ===== Favoritos (guardados en el navegador) =====
const Favs = {
  key: 'crespiel:favoritos',
  all() { try { return JSON.parse(localStorage.getItem(this.key)) || [] } catch { return [] } },
  has(h) { return this.all().includes(h) },
  toggle(h) {
    const list = this.all();
    const i = list.indexOf(h);
    i >= 0 ? list.splice(i, 1) : list.push(h);
    localStorage.setItem(this.key, JSON.stringify(list));
    Favs.refreshCount();
    return i < 0;
  },
  refreshCount() {
    const el = document.querySelector('[data-fav-count]');
    if (!el) return;
    const n = Favs.all().length;
    el.textContent = n;
    el.hidden = n === 0;
  }
};

document.addEventListener('DOMContentLoaded', () => {
  Favs.refreshCount();

  // Botón en la ficha de producto
  const btn = document.querySelector('[data-fav-toggle]');
  if (btn) {
    const paint = saved => {
      btn.classList.toggle('saved', saved);
      btn.querySelector('.fav-heart').textContent = saved ? '♥' : '♡';
      btn.querySelector('[data-fav-label]').textContent = saved ? 'Guardado en favoritos' : 'Guardar en favoritos';
    };
    paint(Favs.has(btn.dataset.handle));
    btn.addEventListener('click', () => paint(Favs.toggle(btn.dataset.handle)));
  }

  // Página de favoritos
  const grid = document.querySelector('[data-fav-grid]');
  if (grid) {
    const empty = document.querySelector('[data-fav-empty]');
    const handles = Favs.all();
    if (!handles.length) { if (empty) empty.hidden = false; return; }
    handles.forEach(async handle => {
      try {
        const p = await (await fetch(`/products/${handle}.js`)).json();
        const card = document.createElement('div');
        card.innerHTML = `
          <a class="product-card" href="${p.url}">
            <div class="product-image">${p.featured_image ? `<img src="${p.featured_image}${p.featured_image.includes('?') ? '&' : '?'}width=700" loading="lazy" alt="">` : ''}</div>
            <h3>${p.title}</h3>
            <span class="price">${(p.price / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })}</span>
          </a>
          <button type="button" class="fav-card-remove">Quitar de favoritos</button>`;
        card.querySelector('.fav-card-remove').addEventListener('click', () => {
          Favs.toggle(handle);
          card.remove();
          if (!Favs.all().length && empty) empty.hidden = false;
        });
        grid.appendChild(card);
      } catch { Favs.toggle(handle); }
    });
  }
});

// ===== Selector de tela por tramos de 25 cm (o de 50 cm con la etiqueta minimo:50) =====
document.addEventListener('DOMContentLoaded', () => {
  const tela = document.querySelector('[data-tela]');
  if (!tela) return;

  const precioTramo = parseInt(tela.dataset.precioTramo, 10); // precio de 25 cm, en céntimos
  const cmEl = tela.querySelector('[data-tela-cm]');
  const qtyEl = tela.querySelector('[data-tela-qty]');
  const totalEl = tela.querySelector('[data-tela-total]');
  const cantidadBox = tela.querySelector('.tela-cantidad');
  const paso = parseInt(tela.dataset.telaPaso, 10) || 1; // 1 = de 25 en 25 cm, 2 = de 50 en 50 cm
  let tramos = paso;

  const formatoEuro = c => (c / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });

  function pintar() {
    const cm = tramos * 25;
    // Mostrar en cm hasta 99 cm; a partir de 1 m, mostrar también los metros
    cmEl.textContent = cm < 100 ? cm : cm;
    // Etiqueta de unidad y equivalencia en metros
    let sufijo = cantidadBox.querySelector('.tela-metros');
    if (!sufijo) {
      sufijo = document.createElement('span');
      sufijo.className = 'tela-metros';
      cantidadBox.appendChild(sufijo);
    }
    if (cm >= 100) {
      const metros = (cm / 100).toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
      cmEl.textContent = cm;
      sufijo.textContent = `cm · ${metros} m`;
    } else {
      sufijo.textContent = 'cm';
    }
    qtyEl.value = tramos;
    const propEl = tela.querySelector('[data-tela-prop]');
    if (propEl) propEl.value = (tramos * 25 >= 100)
      ? (tramos * 25 / 100).toLocaleString('es-ES') + ' m'
      : (tramos * 25) + ' cm';
    totalEl.textContent = formatoEuro(precioTramo * tramos);
  }

  tela.querySelector('[data-tela-mas]').addEventListener('click', () => {
    tramos += paso;
    pintar();
  });
  tela.querySelector('[data-tela-menos]').addEventListener('click', () => {
    if (tramos - paso >= paso) { tramos -= paso; pintar(); }
  });

  pintar();
});

// ===== Botones +/- de longitud de tela en la CESTA =====
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-cart-tela]').forEach(stepper => {
    const key = stepper.dataset.lineKey;
    const paso = parseInt(stepper.dataset.telaPaso, 10) || 1; // 1 = 25 cm, 2 = 50 cm
    const menos = stepper.querySelector('[data-cart-tela-menos]');
    const mas = stepper.querySelector('[data-cart-tela-mas]');

    async function cambiar(nuevoTramos) {
      if (nuevoTramos < paso) return; // no baja del mínimo (25 o 50 cm)
      const cm = nuevoTramos * 25;
      const etiqueta = cm >= 100
        ? (cm / 100).toLocaleString('es-ES') + ' m'
        : cm + ' cm';
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: key,
            quantity: nuevoTramos,
            properties: { _tela: etiqueta }
          })
        });
        location.reload();
      } catch (e) {
        location.reload();
      }
    }

    // Averiguamos los tramos actuales a partir del texto ("75 cm" -> 3)
    function tramosActuales() {
      const texto = stepper.querySelector('[data-cart-tela-cm]').textContent;
      if (texto.includes('m') && !texto.includes('cm')) {
        return Math.round(parseFloat(texto.replace(',', '.')) * 100 / 25);
      }
      return Math.round(parseInt(texto, 10) / 25);
    }

    // Redondea al múltiplo del paso por si la línea venía con una medida antigua
    function tramosAjustados() {
      return Math.ceil(tramosActuales() / paso) * paso;
    }

    mas.addEventListener('click', () => cambiar(tramosAjustados() + paso));
    menos.addEventListener('click', () => cambiar(tramosAjustados() - paso));
  });
});

// ===== Swatches de color en la ficha de producto =====
document.addEventListener('DOMContentLoaded', () => {
  const picker = document.querySelector('[data-variant-picker]');
  if (!picker) return;

  const swatches = picker.querySelectorAll('[data-swatch]');
  const hiddenInput = picker.querySelector('[data-selected-variant]');
  const mainImg = document.querySelector('[data-gallery-main] img');
  const priceEl = document.querySelector('[data-price]');
  const compareEl = document.querySelector('[data-compare]');

  swatches.forEach(swatch => {
    swatch.addEventListener('click', () => {
      if (swatch.getAttribute('aria-disabled') === 'true') return;

      // marcar seleccionado
      swatches.forEach(s => { s.classList.remove('is-selected'); s.setAttribute('aria-pressed', 'false'); });
      swatch.classList.add('is-selected');
      swatch.setAttribute('aria-pressed', 'true');

      // actualizar variante que se compra
      if (hiddenInput) hiddenInput.value = swatch.dataset.variantId;

      // actualizar imagen principal (reemplazando el nodo para evitar conflicto con el zoom)
      const galleryImg = document.querySelector('[data-gallery-main] img');
      if (galleryImg && swatch.dataset.media) {
        const nuevaImg = galleryImg.cloneNode(false);
        nuevaImg.src = swatch.dataset.media;
        nuevaImg.removeAttribute('srcset');
        galleryImg.replaceWith(nuevaImg);
      }

      // actualizar precio
      if (priceEl && swatch.dataset.variantPrice) priceEl.textContent = swatch.dataset.variantPrice;
      if (compareEl) {
        if (swatch.dataset.variantCompare) { compareEl.textContent = swatch.dataset.variantCompare; compareEl.hidden = false; }
        else compareEl.hidden = true;
      }

      // actualizar descripción del diseño (metacampo por variante)
      const descEl = document.querySelector('[data-variant-desc-display]');
      if (descEl) {
        if (swatch.dataset.variantDesc) {
          descEl.textContent = swatch.dataset.variantDesc;
          descEl.hidden = false;
        } else {
          descEl.hidden = true;
        }
      }

      // actualizar stock disponible según la variante elegida
      updateStockForVariant(swatch.dataset.maxStock);
    });
  });
});

function updateStockForVariant(maxStock) {
  const qtyInput = document.querySelector('#Qty');
  const note = document.querySelector('[data-stock-note]');
  const row = document.querySelector('[data-qty-row]');
  if (!qtyInput || !row) return;

  const contactUrl = row.dataset.contactUrl || '/';

  if (maxStock === '' || maxStock === undefined) {
    qtyInput.removeAttribute('max');
    qtyInput.dataset.maxStock = '';
    if (note) note.hidden = true;
    return;
  }

  qtyInput.max = maxStock;
  qtyInput.dataset.maxStock = maxStock;
  if (parseInt(qtyInput.value, 10) > parseInt(maxStock, 10)) {
    qtyInput.value = maxStock;
  }
  if (note) {
    note.hidden = false;
    note.innerHTML = `Quedan ${maxStock} disponibles online. ¿Necesitas más? <a href="${contactUrl}">Consúltanos</a>, puede que tengamos stock adicional en tienda.`;
  }
}

(function(){
  var toggle = document.querySelector('[data-view-toggle]');
  var grid = document.querySelector('[data-collection-grid]');
  if(!toggle || !grid) return;

  var STORAGE_KEY = 'crespiel-collection-view';
  var buttons = toggle.querySelectorAll('[data-view-btn]');

function applyView(view){
    if(view === '1'){
      grid.classList.add('is-single');
      grid.classList.remove('is-double');
    } else {
      grid.classList.add('is-double');
      grid.classList.remove('is-single');
    }
    buttons.forEach(function(btn){
      btn.classList.toggle('is-active', btn.getAttribute('data-view-btn') === view);
    });
  }

  var saved = localStorage.getItem(STORAGE_KEY) || '2';
  applyView(saved);

  buttons.forEach(function(btn){
    btn.addEventListener('click', function(){
      var view = btn.getAttribute('data-view-btn');
      localStorage.setItem(STORAGE_KEY, view);
      applyView(view);
    });
  });
})();

// ===== Añadir a la cesta sin recargar la página =====
document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('#ProductForm');
  if (!form) return;

  const submitBtn = form.querySelector('.add-to-cart');

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const qtyInput = form.querySelector('#Qty');
    if (qtyInput) {
      const qty = parseInt(qtyInput.value, 10);
      if (isNaN(qty) || qty < 1) {
        qtyInput.value = 1;
        showToast('La cantidad mínima es 1 unidad', true);
        return;
      }
      const max = qtyInput.dataset.maxStock;
      if (max && qty > parseInt(max, 10)) {
        qtyInput.value = max;
        showToast(`Solo quedan ${max} unidades online. Si necesitas más, consúltanos: puede que tengamos stock en tienda.`, true);
        return;
      }
    }

    if (submitBtn) submitBtn.disabled = true;

    try {
      const formData = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      });
      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.description || 'No se ha podido añadir el producto');
      }

      // Actualizar el contador de la cesta en el header
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      const totalItems = cart.items.reduce((total, item) => {
        return total + (item.properties && item.properties._tela ? 1 : item.quantity);
      }, 0);

      let cartCount = document.querySelector('.cart-button span');
      if (totalItems > 0) {
        if (!cartCount) {
          cartCount = document.createElement('span');
          document.querySelector('.cart-button')?.appendChild(cartCount);
        }
        cartCount.textContent = totalItems;
      } else if (cartCount) {
        cartCount.remove();
      }

      showToast('Producto añadido a la cesta');
    } catch (err) {
      showToast(err.message || 'Ha ocurrido un error', true);
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  });
});

function showToast(message, isError) {
  let toast = document.querySelector('[data-toast]');
  if (!toast) {
    toast = document.createElement('div');
    toast.setAttribute('data-toast', '');
    document.body.appendChild(toast);
  }
  toast.textContent = message;
  toast.classList.toggle('is-error', !!isError);
  toast.classList.add('is-visible');
  clearTimeout(toast._hideTimer);
  toast._hideTimer = setTimeout(() => {
    toast.classList.remove('is-visible');
  }, 2600);
}

// ===== Cantidad: evitar que se quede en 0, vacío, o por encima del stock =====
document.addEventListener('DOMContentLoaded', () => {
  const qty = document.querySelector('#Qty');
  if (!qty) return;
  qty.addEventListener('blur', () => {
    if (qty.value === '' || parseInt(qty.value, 10) < 1) {
      qty.value = 1;
      return;
    }
    const max = qty.dataset.maxStock;
    if (max && parseInt(qty.value, 10) > parseInt(max, 10)) {
      qty.value = max;
      showToast(`Solo quedan ${max} unidades online. Si necesitas más, consúltanos: puede que tengamos stock en tienda.`, true);
    }
  });
});

// ===== Constructor de Canastillas personalizables =====
document.addEventListener('DOMContentLoaded', () => {
  const builder = document.querySelector('[data-canastilla-builder]');
  if (!builder) return;

  const groups = builder.querySelectorAll('[data-group]');
  const selections = {};

  const groupLabels = {
    'sujetachupetes': 'Sujeta-chupetes',
    'portachupetes': 'Portachupetes',
    'tela-delantera': 'Tela delantera',
    'tela-trasera': 'Tela trasera',
    'cesta': 'Cesta',
    'tela-exterior': 'Tela exterior',
    'tela-interior': 'Tela interior',
    'personalizacion': 'Personalización',
    'color-bordado': 'Color del bordado',
    'color-vinilo': 'Color del vinilo'
  };

  function updateSummary() {
    const summaryText = builder.querySelector('[data-builder-summary-text]');
    const addBtn = builder.querySelector('[data-builder-add]');
    const missing = [];
    groups.forEach(group => {
      if (group.hidden) return;
      const key = group.dataset.group;
      if (!selections[key]) missing.push(groupLabels[key] || key);
    });
    if (missing.length) {
      summaryText.textContent = `Falta elegir: ${missing.join(', ')}.`;
      addBtn.disabled = true;
    } else {
      const resumen = Array.from(groups)
        .filter(g => !g.hidden)
        .map(g => `${groupLabels[g.dataset.group] || g.dataset.group}: ${selections[g.dataset.group]}`)
        .join(' · ');
      summaryText.textContent = resumen || 'Tu canastilla está lista.';
      addBtn.disabled = false;
    }
  }

  function selectSwatch(group, swatch) {
    group.querySelectorAll('[data-swatch-builder]').forEach(s => s.classList.remove('is-selected'));
    swatch.classList.add('is-selected');
    selections[group.dataset.group] = swatch.dataset.label;
  }

  groups.forEach(group => {
    group.querySelectorAll('[data-swatch-builder]').forEach(swatch => {
      swatch.addEventListener('click', () => {
        selectSwatch(group, swatch);

        const textoBox = group.querySelector('[data-personalizacion-texto]');
        if (textoBox) textoBox.hidden = swatch.dataset.needsText !== 'true';

        if (group.dataset.group === 'personalizacion') {
          const bordadoGroup = builder.querySelector('[data-group="color-bordado"]');
          const viniloGroup = builder.querySelector('[data-group="color-vinilo"]');
          if (bordadoGroup) bordadoGroup.hidden = swatch.dataset.colorGroup !== 'color-bordado';
          if (viniloGroup) viniloGroup.hidden = swatch.dataset.colorGroup !== 'color-vinilo';
        }

        updateSummary();
      });
    });
  });

  document.querySelectorAll('[data-preset-sujetachupetes]').forEach(btn => {
    btn.addEventListener('click', () => {
      const mapping = {
        'sujetachupetes': btn.dataset.presetSujetachupetes,
        'portachupetes': btn.dataset.presetPortachupetes,
        'tela-delantera': btn.dataset.presetTelaDelantera,
        'tela-trasera': btn.dataset.presetTelaTrasera,
        'cesta': btn.dataset.presetCesta
      };
      let missing = false;
      groups.forEach(group => {
        const key = group.dataset.group;
        const value = mapping[key];
        if (!value) return;
        let target = null;
        if (key === 'tela-delantera' || key === 'tela-trasera') {
          target = group.querySelector(`[data-swatch-builder][data-handle="${value}"]`);
        } else {
          target = Array.from(group.querySelectorAll('[data-swatch-builder]')).find(
            s => s.dataset.label.trim().toLowerCase() === value.trim().toLowerCase()
          );
        }
        if (target) {
          selectSwatch(group, target);
        } else {
          missing = true;
        }
      });
      updateSummary();
      builder.scrollIntoView({ behavior: 'smooth', block: 'start' });

      const note = btn.closest('.combo-card')?.querySelector('[data-combo-unavailable]');
      if (note) {
        if (missing) {
          const contactUrl = btn.dataset.contactUrl || '/';
          note.innerHTML = `Actualmente no disponemos de todos los productos de esta cesta en la web. <a href="${contactUrl}">Contáctanos</a> para consultar disponibilidad en tienda.`;
          note.hidden = false;
        } else {
          note.hidden = true;
        }
      }
    });
  });

  updateSummary();

  const addBtn = builder.querySelector('[data-builder-add]');
  addBtn?.addEventListener('click', async () => {
    const variantId = addBtn.dataset.variantId;
    if (!variantId) {
      showToast('Falta configurar el producto de la canastilla', true);
      return;
    }
    addBtn.disabled = true;
    try {
      const properties = {};
      groups.forEach(group => {
        if (group.hidden) return;
        const key = group.dataset.group;
        properties[groupLabels[key] || key] = selections[key];
      });

      const textoInput = builder.querySelector('[data-personalizacion-input]');
      if (textoInput && !textoInput.closest('[hidden]') && textoInput.value.trim()) {
        properties['Texto de personalización'] = textoInput.value.trim();
      }

      const bordadoPiezas = Array.from(builder.querySelectorAll('[data-bordado-pieza]:checked')).map(cb => cb.value);
      const bordadoNombre = builder.querySelector('[data-bordado-nombre]')?.value.trim();
      if (bordadoPiezas.length && bordadoNombre) {
        properties['Bordado del nombre'] = `"${bordadoNombre}" en: ${bordadoPiezas.join(', ')}`;
      }

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1, properties })
      });
      if (!res.ok) throw new Error('No se ha podido añadir la canastilla');

      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      const totalItems = cart.items.reduce((total, item) => {
        return total + (item.properties && item.properties._tela ? 1 : item.quantity);
      }, 0);
      let cartCount = document.querySelector('.cart-button span');
      if (totalItems > 0) {
        if (!cartCount) {
          cartCount = document.createElement('span');
          document.querySelector('.cart-button')?.appendChild(cartCount);
        }
        cartCount.textContent = totalItems;
      }
      showToast('Se ha añadido a la cesta');
    } catch (err) {
      showToast(err.message || 'Ha ocurrido un error', true);
    } finally {
      addBtn.disabled = false;
    }
  });
});

// ===== Lightbox para imágenes ampliables =====
document.addEventListener('DOMContentLoaded', () => {
  const overlay = document.querySelector('[data-lightbox-overlay]');
  const img = overlay?.querySelector('[data-lightbox-img]');
  if (!overlay || !img) return;

  function openLightbox(btn) {
    img.src = btn.dataset.full;
    img.alt = btn.getAttribute('aria-label') || '';
    overlay.classList.add('open');
  }
  function closeLightbox() {
    overlay.classList.remove('open');
    img.src = '';
  }

  document.querySelectorAll('[data-lightbox]').forEach(btn => {
    btn.addEventListener('click', () => openLightbox(btn));
  });

  overlay.querySelector('[data-lightbox-close]')?.addEventListener('click', closeLightbox);
  overlay.addEventListener('click', (e) => { if (e.target === overlay) closeLightbox(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeLightbox(); });
});

// ===== Personalización (bordado/vinilo) en la ficha de producto normal =====
document.addEventListener('DOMContentLoaded', () => {
  const box = document.querySelector('[data-product-personalizacion]');
  if (!box) return;

  const tipoInput = box.querySelector('[data-personaliza-input]');
  const colorInput = box.querySelector('[data-personaliza-color-input]');
  const textoBox = box.querySelector('[data-personaliza-texto]');

  box.querySelectorAll('[data-personaliza-swatch]').forEach(swatch => {
    swatch.addEventListener('click', () => {
      box.querySelectorAll('[data-personaliza-swatch]').forEach(s => s.classList.remove('is-selected'));
      swatch.classList.add('is-selected');
      if (tipoInput) tipoInput.value = swatch.dataset.label;

      if (textoBox) textoBox.hidden = swatch.dataset.needsText !== 'true';

      box.querySelectorAll('[data-color-group]').forEach(group => {
        group.hidden = group.dataset.colorGroup !== swatch.dataset.colorGroup;
      });

      if (swatch.dataset.needsText !== 'true' && colorInput) colorInput.value = '';
    });
  });

  box.querySelectorAll('[data-personaliza-color]').forEach(swatch => {
    swatch.addEventListener('click', () => {
      const group = swatch.closest('[data-color-group]');
      group?.querySelectorAll('[data-personaliza-color]').forEach(s => s.classList.remove('is-selected'));
      swatch.classList.add('is-selected');
      if (colorInput) colorInput.value = swatch.dataset.label;
    });
  });

  const ubicacionInput = box.querySelector('[data-personaliza-ubicacion-input]');
  box.querySelectorAll('[data-personaliza-ubicacion]').forEach(btn => {
    btn.addEventListener('click', () => {
      box.querySelectorAll('[data-personaliza-ubicacion]').forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      if (ubicacionInput) ubicacionInput.value = btn.dataset.label;
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-swatch-scroll]').forEach(wrap => {
    const track = wrap.querySelector('.swatches');
    wrap.querySelector('[data-scroll-prev]')?.addEventListener('click', () => track.scrollBy({ left: -240, behavior: 'smooth' }));
    wrap.querySelector('[data-scroll-next]')?.addEventListener('click', () => track.scrollBy({ left: 240, behavior: 'smooth' }));
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-swatch-search]').forEach(input => {
    const group = input.closest('.builder-group');
    const swatches = group.querySelectorAll('.swatch[data-swatch-builder]');
    input.addEventListener('input', () => {
      const query = input.value.trim().toLowerCase();
      swatches.forEach(swatch => {
        const label = (swatch.dataset.label || '').toLowerCase();
        swatch.classList.toggle('is-filtered-out', query !== '' && !label.includes(query));
      });
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-gallery-flip]').forEach(wrap => {
    const btn = wrap.querySelector('[data-gallery-flip-btn]');
    btn?.addEventListener('click', () => {
      wrap.classList.toggle('is-flipped');
      btn.textContent = wrap.classList.contains('is-flipped') ? '⟲ Ver delante' : '⟲ Ver detrás';
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-piece-flip].has-back').forEach(item => {
    item.addEventListener('click', (e) => {
      if (e.target.closest('[data-lightbox]')) return;
      item.classList.toggle('is-flipped');
    });
  });
});